import { loadBedroomsData } from "@prmf/site-data";
import { ShouldRevalidateFunctionArgs } from "@remix-run/react";
export { BedroomList as default } from "@prmf/site-screens";

export async function loader() {
  const bedrooms = await loadBedroomsData();
  return { bedrooms };
}

export function shouldRevalidate({
  defaultShouldRevalidate,
  formAction,
}: ShouldRevalidateFunctionArgs) {
  if (formAction === "/account/moodboard") return false;
  return defaultShouldRevalidate;
}
